import React, { useState } from "react";
import {
  Container,
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavbarToggler,
} from "reactstrap";
import { NavLink } from "react-router-dom";

const Header = props => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);

  return (
    <Navbar expand="md" className="navbar-dark bg-dark">
      <Container>
        <NavbarBrand href="/">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151.88 141.86">
            <title>Trialgle Logo</title>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <polygon points="6.09 116.91 70.25 0 48.38 2.12 0 121.67 69.43 120.42 6.09 116.91" />
                <polygon points="72.53 0 38.9 60.75 73.61 7.66 142.78 121.67 151.88 101.67 72.53 0" />
                <polygon points="133.97 121.09 0.64 123.98 13.41 141.86 141.14 123.98 105.34 64.48 133.97 121.09" />
                <polygon points="114.06 107.98 92.41 70.48 70.76 32.98 49.11 70.48 27.46 107.98 70.76 107.98 114.06 107.98" />
              </g>
            </g>
          </svg>
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} />
        <Collapse isOpen={!collapsed} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink to="/portfolio" className="nav-link">
                Portfolio
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/about" className="nav-link">
                About
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/contact" className="nav-link">
                Contact
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
